














































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import NavigatorLink from './NavigatorLink.vue';

@Component({
    components: { SvgIcon, NavigatorLink },
})
export default class NavigatorItem extends Vue {
    @Prop()
    public readonly id!: string;

    @Prop()
    public readonly to!: string;

    @Prop()
    public readonly disabled!: boolean;

    @Prop()
    public readonly hasParent!: boolean;

    @Prop()
    public readonly hasChildren!: boolean;

    @Prop()
    public readonly active!: boolean;

    @Prop()
    public readonly semiActive!: boolean;

    @Prop()
    public readonly attrs!: Record<string, string>;

    @Prop()
    public readonly linePrimary!: string;

    @Prop()
    public readonly lineSecondary!: string;

    @Emit('click')
    public onClick() {}

    @Emit('parent-button-click')
    public onParentButtonClick() {}

    @Emit('children-button-click')
    public onChildrenButtonClick() {}
}
